import { RadioGroup as WixRadioGroup } from '@wix/design-system';

export default WixRadioGroup;
